var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},_vm._l((_vm.key),function(item){return _c('el-table-column',{key:item,attrs:{"prop":item,"sortable":"","label":item==='all'?'总用户数':item,"width":"180"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }